// extracted by mini-css-extract-plugin
module.exports = {"form":"AuthForm_form__mfPLr","logo":"AuthForm_logo__2P8x1","title":"AuthForm_title__3nnxa"};